<template>
  <div class="form_index">
    <el-dialog
      class="self_dialog add_form_dialog"
      :title="$store.state.add_form_item.form_item_type == 'add' ? $t('view_form_dialog_add_form_item_184') : $t('view_form_dialog_add_form_item_185')"
      :visible.sync="$store.state.add_form_item.add_form_item_show"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      width="580px"
      @close="closeModule"
      :append-to-body="true">
      <div class="form_body" style="height: 420px;overflow-y: auto;">
        <div class="form_header">
          <my_input :title="$t('view_form_dialog_add_form_item_186')" :maxlength="100" type="one_level" titleWidth="40" width="212" :value.sync="formItemTitle"></my_input>
        </div>
        <div class="setlinePopup">
          <div class="setTitlePopup">{{$t('view_form_dialog_add_form_item_187')}}</div>
          <div class="setButtonPopup" v-for="(item,index) in $store.state.options.formItemOneRow" :key="index" @click="clickItem(item.name)">
            <div :id="item.name" class="typeButtonPopup" :class="selectName == item.name ? 'typeButtonPopupActive': ''">
              <div class="content">
                <div :class="item.icon">
                  &nbsp;
                </div>
                <span v-text="$t(item.title)" :title="$t(item.title)"></span>
              </div>
            </div>
          </div>
          <div class="setlinePopup itemLinePopup">
            <div class="setTitlePopup">
              &nbsp;
            </div>
            <div class="setButtonPopup" v-for="(item,index) in $store.state.options.formItemTwoRow" :key="index" @click="clickItem(item.name)">
              <div :id="item.name" class="typeButtonPopup" :class="selectName == item.name ? 'typeButtonPopupActive': ''">
                <div class="content">
                  <div :class="item.icon">
                    &nbsp;
                  </div>
                  <span v-text="$t(item.title)" :title="$t(item.title)"></span>
                </div>
              </div>
            </div>
            <!--更多-->
            <div class="setButtonPopup">
              <div id="typePopup18" class="typeButtonPopup">
                <div class="content" @click="isShow">
                  <span>{{$t('view_form_dialog_add_form_item_188')}}</span>
                  <div class="icon_more" :class="moreIsShow == 'true' ? 'icon_up': ''">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--更多-->
          <div id="more" v-if="moreIsShow == 'true'">
            <div class="setlinePopup itemLinePopup" v-for="(moreItem,index) in $store.state.options.moreList" :key="index">
              <div class="setTitlePopup">
                &nbsp;
              </div>
              <div class="setButtonPopup" v-for="(item,index) in moreItem.children" :key="index" @click="clickItem(item.name)">
                <div :id="item.name" class="typeButtonPopup" :class="selectName == item.name ? 'typeButtonPopupActive': ''">
                  <div class="content">
                    <div :class="item.icon">
                      &nbsp;
                    </div>
                    <span v-text="$t(item.title)" :title="$t(item.title)"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both">
          <my_input
            v-if="selectName !== 'radio' && selectName !== 'checkbox'
             && selectName !== 'provinces' && selectName !=='upload'
             && selectName !== 'text'"
            :title="$t('view_form_dialog_add_form_item_189')"
            :maxlength="18"
            type="one_level"
            titleWidth="115"
            width="212"
            :value.sync="tipsText"></my_input>
          <my_radio
            v-if="selectName == 'input'"
            titleWidth= "115"
            hiddenIsShow="false"
            :selectValue.sync="formItem.limitType"
            :title="$t('view_form_dialog_add_form_item_190')">
            <div slot="pull_down_control">
             <p class="set_one_level margin_left">
               <my_input_number
                 :title="$t('view_form_dialog_add_form_item_191')"
                 width="60"
                 titleWidth="52"
                 type="one_level"
                 symbol=""
                 @change="change_minValue"
                 :value.sync="minValue"
                 :min="1"
                 :max="99"
               ></my_input_number>
               <span>{{$t('view_form_dialog_add_form_item_192')}}</span>
             </p>
              <p class="set_one_level margin_left">
                <my_input_number
                  :title="$t('view_form_dialog_add_form_item_193')"
                  width="60"
                  titleWidth="52"
                  symbol=""
                  @change="change_maxValue"
                  type="one_level"
                  :value.sync="maxValue"
                  :min="1"
                  :max="100"
                ></my_input_number>
                <span>{{$t('view_form_dialog_add_form_item_192')}}</span>
              </p>
              <p class="margin_left">{{$t('view_form_dialog_add_form_item_194')}}</p>
            </div>
          </my_radio>
          <my_input
            v-if="selectName == 'radio' || selectName == 'checkbox' || selectName == 'select'"
            :title="$t('view_form_dialog_add_form_item_195')"
            type="one_level"
            titleWidth="115"
            width="310"
            inputType="textarea"
            :value.sync="formItem.selectItem"
            :rows="4"></my_input>
          <p class="margin_left"
             style="margin-top: -5px"
             v-if="selectName == 'radio' || selectName == 'checkbox' || selectName == 'select'">{{$t('view_form_dialog_add_form_item_196')}}</p>
          <my_radio
            v-if="selectName == 'date'"
            titleWidth="118"
            :option="$store.state.options.dataTypeList"
            :selectValue.sync="formItem.dateType"
            :title="$t('view_form_dialog_add_form_item_197')">
          </my_radio>
          <my_radio
            v-if="selectName == 'date' && formItem.dateType == 'date'"
            titleWidth="118"
            :option="$store.state.options.accuracyList"
            :selectValue.sync="formItem.accuracyType"
            :title="$t('view_form_dialog_add_form_item_198')">
          </my_radio>
          <!--phone-->
          <my_radio
            v-if="selectName == 'phone'"
            titleWidth="118"
            :option="$store.state.options.areaCodeList"
            :selectValue.sync="formItem.areaSelect"
            :title="$t('view_form_dialog_add_form_item_199')">
          </my_radio>
          <my_radio
            v-if="selectName == 'phone'"
            titleWidth="118"
            :option="$store.state.options.enterDigitsList"
            :selectValue.sync="formItem.enterDigitsSelect"
            :title="$t('view_form_dialog_add_form_item_200')">
          </my_radio>
          <!--provinces-->
          <my_radio
            v-if="selectName == 'provinces'"
            titleWidth="118"
            :option="$store.state.options.countyList"
            :selectValue.sync="formItem.countySelect"
            :title="$t('view_form_dialog_add_form_item_201')">
          </my_radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="closeModule">{{$t('view_public_topbar_14')}}</el-button>
        <el-button type="primary" @click="confirmEvent(formItem)">{{$t('view_public_topbar_15')}}</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import i18n from '../../language/index'

  import Cookies from 'js-cookie'
  export default {
    name: 'form_index',
    data() {
      return {
        formTitle: '',
        dialogVisible: true,
        moreIsShow: this.$store.state.add_form_item.form_item_type === 'edit' ? 'true' : 'false',
        selectName: this.$store.state.add_form_item.select_name,
        cur_item_name: Cookies.get('cur_item_name_wm'),
        cur_item_index: Cookies.get('cur_item_index_wm'),
        form_item_type: this.$store.state.add_form_item.form_item_type,
        formItemTitle: '', // 项名称
        minValue: 1, // 最小值
        maxValue: 100, // 最大值
        tipsText: '',//提醒文字
        isFirst: true,
        formItem: {}

      }
    },
    computed: {
    },
    watch:{
    	'selectName'(val) {
    		this.getFormItem()
    	}
    },
    methods: {
      getFormItem() {
      	let data = JSON.parse(JSON.stringify(this.$store.state.options.formItemListNew[this.selectName]))
      	const curData = JSON.parse(JSON.stringify(this.$store.state.add_form_item.cur_form_item))
      	if(this.form_item_type === 'edit'
      	 && curData.moduleName !== ''
      	 && this.selectName === curData.moduleName) {
      		data = curData
      		if(this.isFirst) {
      			this.formItemTitle = data.title
      			this.tipsText = data.placeholder
      			if(this.selectName === 'input') {
      				this.minValue = data.minValue.value
      				this.maxValue = data.maxValue.value
      			}
      			this.isFirst = false
      		}
      	}
      	this.formItem = data
      },
      change_minValue () {
        if (this.minValue > this.maxValue) {
        this.formItem.minValue.value = this.formItem.minValue.min
        this.minValue = this.formItem.minValue.min
        this.$message.warning(i18n.t('view_form_dialog_add_form_item_202', [this.minValue,this.maxValue]))
       }
      },
      change_maxValue (val) {
        if (this.maxValue < this.minValue) {
        this.formItem.maxValue.value = this.formItem.maxValue.max
        this.maxValue = this.formItem.maxValue.max
        this.$message.warning(i18n.t('view_form_dialog_add_form_item_203', [this.minValue,this.maxValue]))
        }
      },
      isShow() {
        this.moreIsShow = this.moreIsShow === 'true' ? 'false' : 'true'
      },
      closeModule() {
        this.dialogVisible = true
        this.$store.commit('add_form_item/set_add_form_item_show', false)
      },
      clickItem(val) {
        this.selectName = val
      },
      confirmEvent(formItem) {
        this.isFirst = true
        formItem.title = this.formItemTitle
        formItem.placeholder = this.tipsText
        if(formItem.moduleName === 'input') {
            formItem.minValue.value = this.minValue
            formItem.maxValue.value = this.maxValue
        }
        if (formItem.title === '') {
          this.$message.warning(i18n.t('view_form_dialog_add_form_item_204'))
          return false
        }
        if(formItem.moduleName == 'radio' || formItem.moduleName == 'checkbox' || formItem.moduleName == 'select') {
          let selectItem = formItem.selectItem.replace(/[\r\n\s]/g, "");
          if(selectItem === '') {
            this.$message.warning(i18n.t('view_form_dialog_add_form_item_205'))
            return false
          }
        }
        const edit_form = this.$store.state.add_form.edit_form
        let fields = edit_form.fields
        if(typeof edit_form.fields == "string") {
          fields = JSON.parse(edit_form.fields)
        }
        if (fields.contentList.length >= 20 && this.form_item_type === 'add') {
          this.$message.warning(i18n.t('view_form_dialog_add_form_item_206'))
          return false
        }
        this.dialogVisible = false
        let num = fields.contentList.length + 1
        formItem.id = num
        const temp = ['radio', 'checkbox', 'select']
        if (temp.indexOf(this.selectName) > -1) {
          const temp = formItem.selectItem.split('\n')
          const options = []
          temp.forEach((item, index) => {
            const title = item.replace(/(^\s*)|(\s*$)/g, '')
            if (title !== '') {
              options.push({
                label: title,
                value: index
              })
            }
          })
          formItem.options = options
        }
        if (this.form_item_type === 'edit') {
          fields.contentList.splice(this.cur_item_index, 1, formItem)
        } else {
          fields.contentList.push(formItem)
        }
        edit_form.fields = JSON.stringify(fields)
        this.$store.commit('add_form/set_edit_form', edit_form)
        Cookies.set('cur_item_index_wm', -1)
        Cookies.set('cur_item_name_wm', '')
        this.closeModule()
      }
    },
    mounted() {
      if(this.$store.state.add_form_item.add_form_item_show) {
      	this.getFormItem()
      }
    }
  }
</script>

<style scoped>
  .form_body {
    margin: 0 10px;
  }
  .form_header {
    margin-right: 13px;
    margin-left: 75px;
    clear: both;
  }
  .form_header p{
    display: flex;
    justify-content: space-between;
    height: 32px;
    margin-bottom: 10px;
    line-height: 32px;
  }
  .margin_left {
    margin-left: 125px;
    color: #999;
    font-size: 12px;
  }
  .margin_left span {
    display: inline-block;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/view/form_dialog/add_form_item.vue